import { supabase } from '../../lib/supabaseClient';
import './SplashScreen.css';

interface SplashScreenProps {
  isAuthenticated: boolean;
  canAttemptLogin?: boolean;
  progress?: number;
  statusTitle: string;
  statusSubtitle: string;
  tip?: string;
}

export function SplashScreen({
  isAuthenticated,
  canAttemptLogin = false,
  progress = 0,
  statusTitle,
  statusSubtitle,
  tip,
}: SplashScreenProps) {
  const handleLogin = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'github',
      options: {
        redirectTo: window.location.origin,
      },
    });
  };

  const showLoginButton = canAttemptLogin && !isAuthenticated;
  const helperText = showLoginButton
    ? 'GitHub 계정과 연동해 전장에 입장하세요.'
    : tip || 'DSM-TCG는 여러분의 후원으로 운용됩니다.';
  const progressLabel =
    progress < 100 ? `동기화 ${Math.round(progress)}%` : '전장이 열리고 있습니다';

  return (
    <div className="splash-screen">
      <div
        className="splash-screen__background"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/splash.png)`,
        }}
      />

      <div className="splash-screen__content">
        <div className="splash-screen__panel">
          <div className="splash-screen__brand">
            <span className="splash-screen__eyebrow">DSM Trading Card Game</span>
            <h1 className="splash-screen__title">{statusTitle}</h1>
            <p className="splash-screen__subtitle">{statusSubtitle}</p>
          </div>

          <div className="splash-screen__status">
            <div className="splash-screen__progress-pill">
              {progressLabel}
              <span className="splash-screen__progress-dot" />
            </div>
            <div className="splash-screen__progress-bar">
              <div
                className="splash-screen__progress-fill"
                style={{ width: `${Math.min(progress, 100)}%` }}
              />
            </div>
          </div>

          <p className="splash-screen__helper">{helperText}</p>

          {showLoginButton && (
            <button
              type="button"
              className="splash-screen__login-button"
              onClick={handleLogin}
            >
              <svg
                className="splash-screen__github-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
                aria-hidden="true"
              >
                <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
              </svg>
              GitHub로 시작하기
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

